/**
 * The one decision behind the account-health restriction probe: may it run right now?
 *
 * The probe reads WhatsApp's account-restriction prefs THROUGH a connected engine
 * (`waAccountRestrictionTool`). With no engine connected there is nothing to read, and on
 * the standalone web app the engine-less `/actions?cmd=whatsappTools.waAccountRestrictionTool`
 * round-trip fails every cycle — a phantom console 400 that alarms users and buys nothing.
 *
 * So we gate on the SAME "is WhatsApp connected?" signal the app header derives
 * (`makeSelectConnectedEnginesState(...).hasWhatsAppConnection`). Kept as a lean pure
 * function so the behaviour is unit-tested without standing up a store or mocking the
 * dynamic tool import.
 */
export interface ConnectionProbeState {
    hasWhatsAppConnection?: boolean;
}

/**
 * True only when a WhatsApp engine is connected. FAILS CLOSED: an unknown/absent
 * connection state returns false, because the gate exists to STOP no-engine probes — a
 * state we cannot read is not evidence of a connected engine.
 */
export const shouldProbeForRestriction = (
    conn: ConnectionProbeState | null | undefined,
): boolean => !!conn?.hasWhatsAppConnection;
